import { useTranslation } from 'react-i18next';

export function Loading({ text }: { text?: string }) {
  const { t } = useTranslation();
  return (
    <p className="govuk-body" role="status">
      {text ?? t('common.loading')}
    </p>
  );
}

export function LoadingPage() {
  const { t } = useTranslation();
  return (
    <>
      {/* data-loading-heading: the route focus follows to the page's heading that replaces this one */}
      <h1 className="govuk-heading-l" tabIndex={-1} data-loading-heading="">
        {t('common.loading')}
      </h1>
      <Loading />
    </>
  );
}
